import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
    clientAccountBasePath,
    clientSubAccountBasePath,
    clientSpecificReportBasePath,
    thoughtLeadershipResourceBasePath,
    clientAccPDBasePath,
    assignReferralBasePath,
    manageReferralBasePath,
    accountTeamMemberBasePath,
    meetingReqBasePath,
    clientUserBasePath,
    adminMsgBasePath,
    managePDBasePath,
    adminUserBasePath
} from "../routes/routePaths";
import { useGetLoggedInUserDetails } from "../hooksAndFunctions/customHooks/useGetLoggedInUserDetails";
import { useTrackActivityMutation } from "../reactQueries/commonRQHooks";

// const sections = [
//     "ClientAccount",
//     "ClientSubAccount",
//     "ClientUser",
//     "ClientSpecificReportAndResources",
//     "ThoughtLeadershipResources",
//     "ManageProgrammeDescriptorRepo",
//     "ManageClientAccountProgrammeDescriptor",
//     "AssignReferralRequests",
//     "ManageReferralRequests",
//     "AccountTeam",
//     "AdminMessages",
//     "MettingRequests",
// ];
// const actionType = [
//     "Created",
//     "Updated",
//     "Downloaded",
//     "Uploaded",
//     "Viewed",
//     "Deleted",
//     "Recovred",
//     "Removed",
//     "EmailInvitationSent"
//      "Activated",
//      "Deactivated"
// ]

const useTrackUserActivity = () => {
    const { loggedInUser } = useGetLoggedInUserDetails();
    const { id: userId } = loggedInUser;

    const location = useLocation()
    const { pathname } = location


    /**geting functionality section */
    const [section, setSection] = useState("");

    const regExp_adminUserBasePath = new RegExp(adminUserBasePath, 'i')
    const regExp_clientAccountBasePath = new RegExp(clientAccountBasePath, 'i')
    const regExp_clientSubAccountBasePath = new RegExp(clientSubAccountBasePath, 'i')
    const regExp_clientSpecificReportBasePath = new RegExp(clientSpecificReportBasePath, 'i')
    const regExp_thoughtLeadershipResourceBasePath = new RegExp(thoughtLeadershipResourceBasePath, 'i')
    const regExp_managePDBasePath = new RegExp(managePDBasePath, 'i')
    const regExp_clientAccPDBasePath = new RegExp(clientAccPDBasePath, 'i')
    const regExp_assignReferralBasePath = new RegExp(assignReferralBasePath, 'i')
    const regExp_manageReferralBasePath = new RegExp(manageReferralBasePath, 'i')
    const regExp_accountTeamMemberBasePath = new RegExp(accountTeamMemberBasePath, 'i')
    const regExp_meetingReqBasePath = new RegExp(meetingReqBasePath, 'i')
    const regExp_adminMsgBasePath = new RegExp(adminMsgBasePath, 'i')
    const regExp_clientUserBasePath = new RegExp(clientUserBasePath, 'i')


    /**add new sections here for new functionality */
    useEffect(() => {
        if (pathname?.search(regExp_adminUserBasePath) !== -1) {
            setSection("AdminUser")
        }
        else if (pathname?.search(regExp_clientAccountBasePath) !== -1) {
            setSection("ClientAccount")
        }
        else if (pathname?.search(regExp_clientSubAccountBasePath) !== -1) {
            setSection("ClientSubAccount")
        }

        else if (pathname?.search(regExp_clientUserBasePath) !== -1) {
            setSection("ClientUser")
        }

        else if (pathname?.search(regExp_clientSpecificReportBasePath) !== -1) {
            setSection("ClientSpecificReportAndResources")
        }

        else if (pathname?.search(regExp_thoughtLeadershipResourceBasePath) !== -1) {
            setSection("ThoughtLeadershipResources")
        }

        else if (pathname?.search(regExp_managePDBasePath) !== -1) {
            setSection("ManageProgrammeDescriptorRepo")
        }

        else if (pathname?.search(regExp_clientAccPDBasePath) !== -1) {
            setSection("ManageClientAccountProgrammeDescriptor")
        }

        else if (pathname?.search(regExp_assignReferralBasePath) !== -1) {
            setSection("AssignReferralRequests")
        }

        else if (pathname?.search(regExp_manageReferralBasePath) !== -1) {
            setSection("ManageReferralRequests")
        }

        else if (pathname?.search(regExp_accountTeamMemberBasePath) !== -1) {
            setSection("AccountTeam")
        }

        else if (pathname?.search(regExp_adminMsgBasePath) !== -1) {
            setSection("AdminMessages")
        }

        else if (pathname?.search(regExp_meetingReqBasePath) !== -1) {
            setSection("MettingRequests")
        }
    }, [pathname])


    /**add error messages for new action */
    const getErrorMsg = ({ actionType, itemId, extraDescription }) => {
        let errorMsg = "";

        if (actionType === "Created" ||
            actionType === "Updated" ||
            actionType === "Deleted" ||
            actionType === "Recovered" ||
            actionType === "Removed"
        ) {
            if (section === "AdminUser") {
                /**add admin roles in  "extraDescription" arg*/
                const extraDescript = !!extraDescription ? `as ${extraDescription}` : ""
                errorMsg = `Id: ${itemId} ${actionType.toLowerCase()} ${extraDescript}`;
            } else {
                errorMsg = `Id: ${itemId} ${actionType.toLowerCase()}`;
            }
        }
        else if (actionType === "Viewed") {
            errorMsg = `Viewed list`;
        }
        else if (actionType === "Downloaded") {
            if (section === "AssignReferralRequests") {
                /**as it does not use GUID to download file */
                errorMsg = `Referral file downloaded`;
            } else {
                errorMsg = `File with GUID: ${itemId} downloaded`;
            }
        }
        else if (actionType === "Uploaded") {
            errorMsg = `File with GUID: ${itemId} uploaded`;
        }
        else if (actionType === "EmailInvitationSent") {
            errorMsg = `Email invitation sent`;
        }
        else if (actionType === "Activated") {
            errorMsg = `Record with id: ${itemId} activated`;
        }
        else if (actionType === "Deactivated") {
            errorMsg = `Record with id: ${itemId} deactivated`;
        }
        else if (actionType === "ReferralAccepted") {
            errorMsg = `Referral with id: ${itemId} accepted`;
        }
        else if (actionType === "ReferralRejected") {
            errorMsg = `Referral with id: ${itemId} rejected`;
        }

        return errorMsg
    }

    const { mutate: trackActivity, isError: isErrorOnTrackActivity, isLoading: isLoadingOnTrackActivity, isSuccess: isSuccessOnTrackActivity, data: dataOnTrackActivity, error: errorOnTrackActivity } = useTrackActivityMutation()

    const callUserActivity = ({ actionType, itemId, activitySuccess, extraDescription }) => {
        const errorMsg = getErrorMsg({ actionType, itemId, extraDescription });

        if (!!activitySuccess) {
            trackActivity({
                Type: `AdminPortal_${section}_${actionType}` || "",
                CreatedBy: userId || "",
                ItemId: itemId || "",
                Value: errorMsg || "",
            })
        }
    }
    return {
        trackActivity: callUserActivity
    }

}
export default useTrackUserActivity